import { Auth } from "aws-amplify";

export const signOutFunction = async () => {
  const res = await Auth.signOut({
    global: false,
  });
  localStorage.clear();
  window.location.reload();
  return res;
};
